/* eslint @typescript-eslint/naming-convention: 0 */
import type { MapSourcePage, MapViewLayout } from '@/wabunka-src/common/utils/googleAnalytics/common/mapSearch';
import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

export interface MapAreaLayerEnterParams {
  source_page: MapSourcePage;
  layout: MapViewLayout;
}

/**
 * 発火タイミング：一覧マップが広域ズーム（エリアラベル層）に入った際（JCAT-5434 / F-29〜F-31）。
 *
 * エリアラベル層はユーザーが自分でズームアウトしないと到達しないため、この機能は A/B を張らずに
 * リリースする。したがって本イベントが唯一の到達計測になる。`map_view_open` に対する比率で見ることで、
 * 「クリックが少ない」のが**到達が少ない**のか**到達しても押されない**のかを切り分ける。
 *
 * 層に入るたびに発火する（ズームイン→ズームアウトの往復は別々に数える）。
 */
export const sendGAWabunkaMapAreaLayerEnterEvent = (sourcePage: MapSourcePage, layout: MapViewLayout) => {
  sendWabunkaGAEvent('map_area_layer_enter', { source_page: sourcePage, layout });
};
